var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfilePageIconArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24.34,
    height: 24.34,
    viewBox: "0 0 24.34 24.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#AFCED1",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180 12.17 12.17)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.17,
    cy: 12.17,
    stroke: "none",
    r: 12.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.17,
    cy: 12.17,
    r: 11.17
  })), /*#__PURE__*/React.createElement("path", {
    d: "m7.751 9.972 4.194 5.65 4.354-5.65",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePageIconArrowDown);
export default __webpack_public_path__ + "static/media/profile--page--icon--arrow--down.44501e30a1aab4b5c232b358dc676b07.svg";
export { ForwardRef as ReactComponent };